export default __webpack_public_path__ + "static/media/060-emergency diversion.8a4411bc.png";